"use strict";

exports.__esModule = true;
var _CalendarSettingsScreen = require("./CalendarSettingsScreen");
Object.keys(_CalendarSettingsScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CalendarSettingsScreen[key]) return;
  exports[key] = _CalendarSettingsScreen[key];
});